import { useEffect, useState } from "react";
import {
  Box,
  Button,
  ButtonProps,
  Grid,
  GridItem,
  Modal,
  ModalContent,
  ModalOverlay,
  Select,
  Text,
  useDisclosure,
  useMediaQuery,
} from "@chakra-ui/react";
import { useBookingContext } from "../../context/BookingContext";
import {
  BookCard,
  BookCardTitle,
  BookCardSubtitle,
} from "../../components/Book/BookCard";
import { BaseSelect } from "../../components/Base/BaseSelect";
import { BookClassCard } from "../../components/Book/BookClassCard";

import {
  Paginator,
  Container,
  Previous,
  usePaginator,
  Next,
  PageGroup,
} from "chakra-paginator";
import { useHistory } from "react-router-dom";
import { BaseText } from "../../components/Base/BaseText";

const SelectClassPage = () => {
  // constants
  const outerLimit = 2;
  const innerLimit = 2;

  const history = useHistory();

  const { stepr } = useBookingContext();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const [isSmall] = useMediaQuery("(max-width: 992px)");
  const [selectedClass, setSelectedClass] = useState(-1);

  const { isDisabled, pagesQuantity, currentPage } = usePaginator({
    total: 100,
    initialState: {
      pageSize: 10,
      currentPage: 1,
      isDisabled: false,
    },
  });

  useEffect(() => {
    stepr.setStep(2);
  }, [stepr]);

  const handleClickContinue = () => {
    /**
     * TODO: validate form
     */
    stepr.nextStep();
    history.push("/book/select-slot");
  };

  // styles
  const baseStyles: ButtonProps = {
    w: 7,
    fontSize: "sm",
  };

  const normalStyles: ButtonProps = {
    ...baseStyles,
    _hover: {
      bg: "gray",
    },
    w: { base: 5, lg: 8 },
    h: { base: 5, lg: 8 },
    minW: { base: 5, lg: 8 },
    bg: "white",
    rounded: "full",
    border: "none",
    color: "#374151",
    fontFamily: "Inter",
    fontSize: "sm",
    fontWeight: "500",
  };

  const activeStyles: ButtonProps = {
    ...normalStyles,
    _hover: {
      bg: "#23428D",
    },
    bg: "#23428D",
    color: "white",
  };

  const separatorStyles: ButtonProps = {
    ...normalStyles,
    boxShadow: "none",
  };

  return (
    <BookCard mt={"10px"} mx="auto">
      <Box
        display={"flex"}
        alignItems={{ lg: "center" }}
        justifyContent={{ lg: "space-between" }}
        flexDirection={{ base: "column", lg: "row" }}
      >
        <Box>
          <BookCardTitle small>Find A Class</BookCardTitle>
          <BookCardSubtitle small>Please find your class</BookCardSubtitle>
        </Box>

        <Box
          display="flex"
          experimental_spaceX={1}
          mt={{ base: 3, lg: 0 }}
          maxW={"176px"}
        >
          <Select
            flexShrink={0}
            flexGrow={1}
            placeholder="Day of the Week"
            fontFamily={"Inter"}
            color={"#374151"}
            fontWeight={"500"}
            fontSize={"sm"}
            width={"full"}
          >
            <option value="option1">Option 1</option>
            <option value="option2">Option 2</option>
            <option value="option3">Option 3</option>
          </Select>

          {isSmall && (
            <Button variant={"outline"} onClick={onOpen}>
              <i className="ri-filter-3-line"></i>
            </Button>
          )}
        </Box>
      </Box>

      {!isSmall ? (
        <Box mt={3}>
          <Text
            fontFamily={"Open Sans"}
            fontWeight={"bold"}
            fontSize={"xs"}
            color={"#050505"}
          >
            Filters
          </Text>
          <Box display={"flex"} mt={1} experimental_spaceX={1}>
            <BaseSelect
              label="Format"
              options={[{ text: "All", value: "all" }]}
            />
            <BaseSelect
              label="Topic"
              options={[{ text: "Robotics", value: "robotics" }]}
            />
            <BaseSelect
              label="Length"
              options={[{ text: "60 mins", value: 60 }]}
            />
            <BaseSelect
              label="Length"
              options={[{ text: "Level", value: "Expert" }]}
            />
          </Box>
        </Box>
      ) : (
        <Modal blockScrollOnMount={false} isOpen={isOpen} onClose={onClose}>
          <ModalOverlay />
          <ModalContent
            m="0"
            w="full"
            bottom="0"
            position="absolute"
            borderRadius="none"
            p={6}
          >
            <BaseText color="#050505" font={["Open Sans", 700, "16px", "15px"]}>
              Filters
            </BaseText>
            <Box mt="6" experimental_spaceY={3}>
              <BaseSelect
                label="Format"
                options={[{ text: "All", value: "all" }]}
              />
              <BaseSelect
                label="Topic"
                options={[{ text: "Robotics", value: "robotics" }]}
              />
              <BaseSelect
                label="Length"
                options={[{ text: "60 mins", value: 60 }]}
              />
              <BaseSelect
                label="Length"
                options={[{ text: "Level", value: "Expert" }]}
              />
            </Box>

            <Button
              mt="9"
              h={"44px"}
              width={"full"}
              rounded="12px"
              fontSize={"sm"}
              border={"none"}
              display={"block"}
              fontFamily="Cairo"
              colorScheme={"blue"}
              bg="#23428D"
              _hover={{ bg: "#1D2B7E" }}
              boxShadow={"0px 1px 2px rgba(31, 41, 55, 0.08)"}
            >
              Apply
            </Button>
            <Button
              variant="outline"
              mt="10px"
              h={"44px"}
              width="full"
              rounded="12px"
              fontSize="sm"
              display="block"
              fontFamily="Cairo"
              color="#374151"
              fontWeight={700}
              border="1px solid #E5E7EB"
              boxShadow="0px 1px 2px rgba(31, 41, 55, 0.08)"
              onClick={onClose}
            >
              Cancel
            </Button>
          </ModalContent>
        </Modal>
      )}

      <Box mt={3}>
        <Text
          color={"#050505"}
          fontSize={"16px"}
          lineHeight={"21px"}
          fontFamily={"Open Sans"}
        >
          45 classes found
        </Text>

        <Grid
          mt={3}
          gap={"10px"}
          templateColumns={{ base: "repeat(1, 1fr)", lg: "repeat(3, 1fr)" }}
        >
          {[...new Array(12).keys()].map((index) => (
            <GridItem w="100%" key={index}>
              <BookClassCard
                selected={selectedClass === index}
                onClick={() => setSelectedClass(index)}
              />
            </GridItem>
          ))}
        </Grid>

        <Paginator
          isDisabled={isDisabled}
          activeStyles={activeStyles}
          innerLimit={innerLimit}
          currentPage={currentPage}
          outerLimit={outerLimit}
          normalStyles={normalStyles}
          separatorStyles={separatorStyles}
          pagesQuantity={pagesQuantity}
          onPageChange={(e) => {
            console.log(e);
          }}
        >
          <Container align="center" justify="center" mt={4}>
            <Box>
              <Previous
                h={9}
                w={9}
                minW={9}
                border="1px solid #E5E7EB"
                rounded={"full"}
                bg="white"
              >
                <i
                  className="ri-arrow-left-s-line"
                  style={{ color: "#374151" }}
                ></i>
              </Previous>
            </Box>
            <PageGroup isInline align="center" experimental_spaceX={4} mx={4} />
            <Box>
              <Next
                h={9}
                w={9}
                minW={9}
                border="1px solid #E5E7EB"
                rounded={"full"}
                bg="white"
              >
                <i
                  className="ri-arrow-right-s-line"
                  style={{ color: "#374151" }}
                ></i>
              </Next>
            </Box>
          </Container>
        </Paginator>

        <Button
          colorScheme={"blue"}
          display={"block"}
          width={"full"}
          rounded="12px"
          h={"44px"}
          fontSize={"sm"}
          fontFamily="Cairo"
          border={"none"}
          mt="3"
          boxShadow={"0px 1px 2px rgba(31, 41, 55, 0.08)"}
          onClick={handleClickContinue}
        >
          Continue
        </Button>
      </Box>
    </BookCard>
  );
};

export { SelectClassPage };
